<template>
  <v-container fluid fill-height pa-0>
    <v-container class="header" fluid>
      <v-layout column align-center justify-center>
        <v-col xl="12" lg="12" md="12" sm="12" class="pb-0">
          <v-layout align-center style="height: 130px">
            <v-layout row style="position: absolute">
              <v-img
                @click="goBack()"
                height="45"
                width="45"
                class="shrink pointer"
                contain
                :src="require('../../assets/back.png')"
              />
              <div class="ml-3" style="color: #fff; width: 96px">Back to profuse.md</div>
            </v-layout>
            <v-col xl="8" lg="9" md="12" sm="12" class="pb-0 mx-auto">
              <Toolbar />
            </v-col>
          </v-layout>
        </v-col>

        <v-col cols="12" xl="8" lg="10" md="12">
          <v-layout row align-center>
            <v-col cols="12" md="6" sm="8">
              <div class="app-title">Brandest</div>

              <div
                class="app-description mt-5"
              >We specialize in native, mobile and web applications development, as well as developing strong and scalable back-end systems to support the projects.</div>

              <v-row class="mt-9 pt-5">
                <v-flex shrink mr-9 mb-5 class="store_btn">
                  <v-img
                    @click="openAppStore"
                    height="58"
                    width="195"
                    contain
                    :src="require('../../assets/app_store.png')"
                  />
                </v-flex>
              </v-row>
            </v-col>

            <v-col cols="6" md="6" sm="4" v-if="!isMobile">
              <v-layout>
                <v-img
                  class="ma-0 pa-0"
                  height="700"
                  width="350"
                  contain
                  :src="require('../../assets/brandest/screenshot.png')"
                />
              </v-layout>
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="game-screens" fluid>
      <v-layout justify-center>
        <v-col cols="12" xl="8" lg="10" md="12">
          <v-layout column>
            <v-flex shrink class="section-title">Game Screens</v-flex>
            <v-flex shrink class="section_divider" mt-2 align-self-center />
          </v-layout>

          <v-layout>
            <v-img contain :src="require('../../assets/brandest/screens.png')" />
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="reviews" fluid>
      <v-layout justify-center>
        <v-col cols="12" xl="8" lg="8" md="10" class="pa-0">
          <v-layout justify-center>
            <div class="user-reviews">User Reviews</div>
          </v-layout>

          <v-carousel cycle hide-delimiters>
            <v-carousel-item v-for="(review, i) in reviews" :key="i">
              <v-sheet color="transparent" height="110%">
                <v-row class="fill-height" align="center" justify="center">
                  <v-layout justify-center column align-center>
                    <div class="review-text">{{ review.text }} Slide</div>
                    <v-rating class="mt-9" readonly color="#FBB831" v-model="review.rating"></v-rating>
                    <div class="review-author">{{ review.author }}</div>
                  </v-layout>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="features-in-app mt-9" fluid>
      <v-layout column>
        <v-flex shrink class="section-title">Features In This App</v-flex>
        <v-flex shrink class="section_divider" mt-2 align-self-center />
      </v-layout>

      <v-layout justify-center>
        <v-col cols="12" xl="6" lg="10" md="12">
          <v-layout justify-center>
            <v-flex class="features-item" shrink>
              <v-img height="81" contain :src="require('../../assets/brandest/crown.png')" />
              <div
                class="features-item-text mt-5"
              >Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical</div>
            </v-flex>
          </v-layout>

          <v-row class="mt-9">
            <v-col lg="4" md="4" sm="4">
              <v-layout column align-center>
                <v-flex class="features-item" shrink>
                  <v-img height="81" contain :src="require('../../assets/brandest/lights.png')" />
                  <div
                    class="features-item-text mt-5"
                  >Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical</div>
                </v-flex>

                <v-flex class="features-item" shrink>
                  <v-img height="81" contain :src="require('../../assets/brandest/t-shirt.png')" />
                  <div
                    class="features-item-text mt-5"
                  >Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical</div>
                </v-flex>
              </v-layout>
            </v-col>

            <v-col lg="4" md="4" sm="4">
              <v-layout align-center>
                <v-img
                  width="340"
                  height="680"
                  contain
                  :src="require('../../assets/brandest/in_app_screenshot.png')"
                />
              </v-layout>
            </v-col>

            <v-col lg="4" md="4" sm="4">
              <v-layout justify-center>
                <v-flex shrink column align-center>
                  <v-flex class="features-item" shrink>
                    <v-img height="81" contain :src="require('../../assets/brandest/brain.png')" />
                    <div
                      class="features-item-text mt-5"
                    >Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical</div>
                  </v-flex>

                  <v-flex class="features-item" shrink>
                    <v-img height="81" contain :src="require('../../assets/brandest/cards.png')" />
                    <div
                      class="features-item-text mt-5"
                    >Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical</div>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="socials" fluid>
      <v-layout justify-center>
        <v-col xl="4" lg="6" sm="12">
          <v-row>
            <v-col md="6" sm="6">
              <v-layout justify-center align-center>
                <v-flex shrink>
                  <v-img height="44" contain :src="require('../../assets/brandest/facebook.png')" />
                </v-flex>
                <div class="social-text">Facebook</div>
              </v-layout>
            </v-col>

            <v-col md="6" sm="6">
              <v-layout justify-center align-center>
                <v-flex shrink>
                  <v-img height="44" contain :src="require('../../assets/brandest/instagram.png')" />
                </v-flex>
                <div class="social-text">Instagram</div>
              </v-layout>
            </v-col>
          </v-row>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="available-device mt-9" fluid>
      <v-layout justify-center>
        <v-col cols="12" xl="6" lg="8" md="10">
          <v-layout column>
            <v-flex shrink class="section-title">Available on all your devices</v-flex>
            <v-flex shrink class="section_divider" mt-2 align-self-center />
          </v-layout>

          <v-layout class="mt-9">
            <v-img
              class="mt-9"
              contain
              :src="require('../../assets/brandest/available_device.png')"
            />
          </v-layout>

          <v-layout justify-center>
            <v-col class="mt-9" md="8" sm="10">
              <div
                class="devices-description mt-9"
              >Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical</div>
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="footer" fluid>
      <v-layout justify-center>
        <v-flex shrink>
          <div class="copyright">Copyright @ 2020 . All rights reserved. | Contact us</div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import Toolbar from "./components/Toolbar.vue";

export default {
  name: "App",
  components: {
    Toolbar
  },
  data() {
    return {
      isMobile: false,
      rating: 0,
      reviews: [
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 4,
          author: "Amanda Dolington"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 2,
          author: "Cris Dolington"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 5,
          author: "John Doe"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 1,
          author: "Alison"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 3,
          author: "Jess"
        }
      ]
    };
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
    goBack() {
      this.$router.go(-1);
    },
    openAppStore() {
      window.open(
        "https://apps.apple.com/us/app/brandest/id1488087758",
        "_blank"
      );
    }
  }
};
</script>

<style scoped>
.header {
  background-image: url("../../assets/brandest/header_bg.png");
  background-size: cover;
  background-position: center;
  height: 110vh;
  min-height: 850px;
}
.app-title {
  font-family: "Montserrat";
  font-size: 40px;
  font-weight: 500;
  line-height: 1.23;
  text-align: left;
  color: #fafafa;
}
.app-description {
  font-family: "Montserrat";
  font-size: 28px;
  font-weight: 300;
  line-height: 1.21;
  text-align: left;
  color: #fafafa;
}
.store_btn {
  cursor: pointer;
}
.section-title {
  font-family: "Montserrat";
  font-size: 50px;
  line-height: 1.22;
  text-align: center;
  color: #141414;
}
.game-screens {
  margin-top: -10vh;
}
.section_divider {
  width: 121px;
  height: 8px;
  background-color: #ac8172;
}
.reviews {
  background-image: url("../../assets/brandest/reviews.png");
  background-size: cover;
  background-position: center;
  background-color: #377d5d;
  padding-top: 40px;
}
.user-reviews {
  font-family: "Montserrat";
  font-size: 40px;
  line-height: 1.23;
  text-align: left;
  color: #ffffff;
}
.review-text {
  font-family: "Montserrat";
  font-size: 28px;
  line-height: 1.14;
  text-align: center;
  color: #ffffff;
  margin-left: 15%;
  margin-right: 15%;
}
.review-author {
  font-family: "Montserrat";
  font-size: 28px;
  font-style: italic;
  line-height: 1.21;
  text-align: left;
  color: #ffffff;
}
.features-item {
  width: 265px;
  justify-content: center;
  text-align: center;
  margin-top: 80px;
}
.features-item-text {
  font-family: "Montserrat";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  text-align: center;
  color: #575757;
}
.socials {
  background-color: #ac8172;
}
.social-text {
  font-family: "Montserrat";
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
}
.devices-description {
  font-family: "Montserrat";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  text-align: center;
  color: #575757;
}
.footer {
  background-color: #000000;
}
.copyright {
  font-family: "Montserrat";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  margin-top: 80px;
  margin-bottom: 80px;
}
.pointer {
  cursor: pointer;
}
</style>